import React, {
    createContext,
    useState,
    useEffect
} from "react";
import {Router, Route, Switch, Redirect} from "react-router-dom";
import history from "./history";
import PrivateRoute from "./components/PrivateRoute";
import "./assets/css/fonts.css";
import "./assets/css/styles.css";

import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import Dideban from "./components/Dideban";
import Motevafa from "./components/Motevafa";
import statesArchive from "./components/statesArchive";
import stateSingle from "./components/stateSingle";
import citySingle from "./components/citySingle";
import MotevafaInsert from "./components/MotevafaInsert";
import MotevafaEdit from "./components/MotevafaEdit";
import KhatmArchive from "./components/KhatmArchive";
import KhatmQoran from "./components/KhatmQoran";
import KhatmSalavat from "./components/KhatmSalavat";
import KhatmQoranSingle from "./components/KhatmQoranSingle";
import Login from "./components/Login";
import ProfileFirst from "./components/ProfileFirst";
import ProfileSec from "./components/ProfileSec";
import Register from "./components/Register";
import SmsEnter from "./components/SmsEnter";
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer, toast, Slide} from 'react-toastify'
import NewKhatm from "./components/NewKhatm";
import DeadList from "./components/DeadList";
import Donate from "./components/Donate";

export const isLogin = createContext(false);
export const loginDispatch = createContext(false);

export const notifySuccessful = () => toast.success('با موفقیت انجام شد', {autoClose: 3500})
export const notifySuccessfulMessage = (message) => toast.success(message, {autoClose: 3500})
export const notifySuccessfulMessageLong = (message) => toast.success(message, {autoClose: 7000})
export const notifyError = () => toast.error('اشکال در ارتباط لطفا دوباره تلاش کنید', {autoClose: 3500})
export const notifyErrorMessage = (message) => toast.error(message, {autoClose: 3500})
export const notifyWarnMessage = (message) => toast.warn(message, {autoClose: 4000})
export const notifyLoginNeeded = () => toast.warning('لطفا وارد حساب کاربری خود شوید', {autoClose: 3500})


const App = () => {
    const [logined, setLogined] = useState(false);
    useEffect(() => {
        setLogined(localStorage.getItem('token') != null)
    }, [])

    return (
        <Router history={history}>
            <isLogin.Provider value={logined}>
                <loginDispatch.Provider value={setLogined}>
                    <div>
                        <ToastContainer rtl closeOnClick pauseOnHover position="top-center" transition={Slide}/>
                        {<Switch>
                            <Route exact path="/" component={Home}/>
                            {/*<PrivateRoute path="/dashboard" component={UserPage} auth={auth} />*/}
                            <Route path="/contact" component={Contact}/>
                            <Route path="/about" component={About}/>
                            <Route path="/mohsenin" component={Dideban}/>
                            <Route exact path="/motevafa/:id" component={Motevafa}/>
                            <Route path="/states" component={statesArchive}/>
                            <Route exact path="/state" component={stateSingle}/>
                            <Route exact path="/city" component={citySingle}/>
                            <Route path="/d-list" component={DeadList}/>
                            <Route path="/khatm-salavat" component={KhatmSalavat}/>
                            <Route path="/khatm" component={KhatmQoran}/>
                            <Route path="/donate" component={Donate}/>
                            <Route path="/khatm-qoran/1" component={KhatmQoranSingle}/>
                            <Route path="/register" component={Register}/>
                            <Route path="/login" component={Login}/>
                            <Route path="/d-list:mine" component={DeadList}/>
                            {/*<Route path="/khatm-archive:mine">*/}
                            {/*    {localStorage.getItem('token') != null ? <KhatmArchive/> : <Redirect to="/login"/>}*/}
                            {/*</Route>*/}
                            <Route path="/khatm-archive" component={KhatmArchive}>
                                {/* {isLogin()} */}
                            </Route>
                            <Route path="/add-motevafa">
                                {localStorage.getItem('token') != null ? <MotevafaInsert/> : <Redirect to="/login"/>}
                            </Route>
                            <Route path="/edit-motevafa/:id">
                                {localStorage.getItem('token') != null ? <MotevafaEdit/> : <Redirect to="/login"/>}
                            </Route>
                            <Route path="/new-khatm">
                                {localStorage.getItem('token') != null ? <NewKhatm/> : <Redirect to="/login"/>}
                            </Route>

                            <Route path="/profile-first">
                                {localStorage.getItem('token') != null ? <ProfileFirst/> : <Redirect to="/login"/>}
                            </Route>
                            <Route path="/profile-sec">
                                {localStorage.getItem('token') != null ? <ProfileSec/> : <Redirect to="/login"/>}
                            </Route>
                            <Route path="/entersms">
                                {localStorage.getItem('token') != null ? <SmsEnter/> : <Redirect to="/login"/>}
                            </Route>
                            <Route
                                component={() => <div style={{textAlign: 'center', width: '100%', marginTop: 100}}>صفحه
                                    مورد نظر پیدا نشد</div>}/>
                        </Switch>}
                    </div>
                </loginDispatch.Provider>
            </isLogin.Provider>
        </Router>
    )
}


export default App;
